{
  "_note": "Kosten in Budgetpunkten. reduction = Anteil, um den die Quelle sinkt (mehrere Aktionen auf dieselbe Quelle wirken multiplikativ). Vereinfachte Modellannahmen.",
  "budget_per_round": 10,
  "rounds": [
    2026,
    2028,
    2030
  ],
  "untargeted_efficacy": 0.5,
  "actions": {
    "carbon_accounting": {
      "label": "Klimabilanz Scope 1–3",
      "short": "Erst messen, dann handeln",
      "scope": "3",
      "cost": 3,
      "targets": {},
      "enables_targeting": true,
      "station": "factory",
      "animation": "scanner",
      "text": "be2morrow wertet Einkaufsliste, Stücklisten und Rechnungen aus: KI ordnet jede Position zu, sucht EPDs und Materialfaktoren. Danach wissen Sie, wo Ihre Hotspots liegen – Scope-3-Maßnahmen wirken doppelt."
    },
    "efficiency": {
      "label": "LED & Druckluft",
      "short": "Effizienz zuerst",
      "scope": "1+2",
      "cost": 2,
      "targets": {
        "power": 0.12,
        "heat": 0.05
      },
      "station": "factory",
      "animation": "lights",
      "text": "LED-Hallenbeleuchtung, Leckage-Ortung im Druckluftnetz, Lastmanagement. Amortisiert sich oft in unter drei Jahren."
    },
    "pv": {
      "label": "PV aufs Dach",
      "short": "Eigenen Strom erzeugen",
      "scope": "1+2",
      "cost": 4,
      "targets": {
        "power": 0.2
      },
      "station": "factory",
      "animation": "solar",
      "text": "Photovoltaik auf Hallendächern deckt einen Teil des Strombedarfs – günstiger als Netzstrom."
    },
    "green_power": {
      "label": "Ökostrom-PPA",
      "short": "Windstrom direkt beziehen",
      "scope": "1+2",
      "cost": 5,
      "targets": {
        "power": 0.7
      },
      "station": "factory",
      "animation": "wind",
      "text": "Langfristiger Liefervertrag mit einem Windpark. Senkt Scope 2 (marktbasiert) deutlich und sichert Preise ab."
    },
    "heat_pump": {
      "label": "Wärmepumpe & Abwärme",
      "short": "Gaskessel raus",
      "scope": "1+2",
      "cost": 6,
      "targets": {
        "heat": 0.6
      },
      "station": "factory",
      "animation": "heatpump",
      "text": "Industrie-Wärmepumpe nutzt Abwärme aus Kompressoren und Prozessen. Der Gaskessel bleibt nur noch für Spitzen."
    },
    "e_fleet": {
      "label": "E-Fuhrpark",
      "short": "Leise und lokal emissionsfrei",
      "scope": "1+2",
      "cost": 4,
      "targets": {
        "fleet": 0.7
      },
      "station": "factory",
      "animation": "efleet",
      "text": "Elektrische Transporter, Stapler und Dienstwagen, geladen mit eigenem PV-Strom."
    },
    "supplier_dialog": {
      "label": "Lieferanten-Klimaziele",
      "short": "Die Top 20 an Bord holen",
      "scope": "3",
      "cost": 3,
      "targets": {
        "metals": 0.1,
        "plastics": 0.1,
        "components": 0.1,
        "goods": 0.1,
        "agri": 0.1,
        "food": 0.1,
        "building": 0.1,
        "packaging": 0.1
      },
      "station": "component_works",
      "animation": "flags",
      "text": "Die größten Lieferanten verpflichten sich auf Reduktionsziele und liefern Primärdaten. Wenige Lieferanten machen meist den Großteil aus."
    },
    "green_assortment": {
      "label": "Nachhaltige Beschaffung",
      "short": "Klimafreundliche Alternativen listen",
      "scope": "3",
      "cost": 4,
      "targets": {
        "goods": 0.2,
        "components": 0.1
      },
      "station": "component_works",
      "animation": "assortment",
      "text": "Einkaufsrichtlinie mit CO2-Kriterien: Produkte mit EPD, refurbished Hardware, langlebige Alternativen bevorzugt."
    },
    "green_steel": {
      "label": "Grüner Stahl & Recyclat",
      "short": "Material mit kleinerem Rucksack",
      "scope": "3",
      "cost": 5,
      "targets": {
        "metals": 0.3
      },
      "station": "steel_mill",
      "animation": "greensteel",
      "text": "Elektrostahl mit hohem Schrottanteil und CO2-reduzierter Stahl. Gleiche Qualität, deutlich kleinerer Fußabdruck."
    },
    "recycled_plastics": {
      "label": "Rezyklat-Kunststoffe",
      "short": "Kreislauf statt Neuware",
      "scope": "3",
      "cost": 4,
      "targets": {
        "plastics": 0.25,
        "packaging": 0.15
      },
      "station": "chem_plant",
      "animation": "recycledplastics",
      "text": "Post-Consumer-Rezyklat und Mehrwegverpackungen ersetzen einen Teil der Neuware."
    },
    "low_carbon_concrete": {
      "label": "CO2-armer Beton",
      "short": "Klinker reduzieren",
      "scope": "3",
      "cost": 5,
      "targets": {
        "building": 0.3
      },
      "station": "quarry",
      "animation": "concrete",
      "text": "Zemente mit weniger Klinkeranteil und optimierte Rezepturen – mit EPD nachweisbar."
    },
    "regional_sourcing": {
      "label": "Regenerative Landwirtschaft",
      "short": "Mit den Höfen zusammen",
      "scope": "3",
      "cost": 4,
      "targets": {
        "agri": 0.2
      },
      "station": "farm",
      "animation": "farm",
      "text": "Programme mit Erzeugern: Futtermittelzusätze, Humusaufbau, weniger Mineraldünger."
    },
    "green_it": {
      "label": "Green IT & Cloud",
      "short": "Rechenzentren mit Ökostrom",
      "scope": "3",
      "cost": 2,
      "targets": {
        "services": 0.2
      },
      "station": "office_park",
      "animation": "greenit",
      "text": "Dienstleister und Rechenzentren mit Ökostrom und Klimazielen auswählen, Hardware länger nutzen."
    },
    "rail_freight": {
      "label": "Bahn statt LKW",
      "short": "Lange Strecken auf die Schiene",
      "scope": "3",
      "cost": 3,
      "targets": {
        "logistics": 0.35
      },
      "station": "logistics_hub",
      "animation": "train",
      "text": "Kombinierter Verkehr: Langstrecke per Bahn, nur die letzte Meile per LKW."
    },
    "video_calls": {
      "label": "Video statt Flug",
      "short": "Reiserichtlinie anpassen",
      "scope": "3",
      "cost": 1,
      "targets": {
        "travel": 0.5
      },
      "station": "airport",
      "animation": "plane",
      "text": "Inlandsflüge streichen, Bahn erster Klasse erlauben, Routinetermine per Video."
    },
    "job_bike": {
      "label": "Jobrad & Deutschlandticket",
      "short": "Pendeln ohne Auspuff",
      "scope": "3",
      "cost": 2,
      "targets": {
        "commute": 0.3
      },
      "station": "suburb",
      "animation": "bikes",
      "text": "Dienstrad-Leasing, Zuschuss zum Deutschlandticket und flexible Homeoffice-Tage."
    },
    "eco_design": {
      "label": "Effizientes Produktdesign",
      "short": "Ihre Produkte sparen beim Kunden",
      "scope": "3",
      "cost": 6,
      "targets": {
        "use_phase": 0.25
      },
      "station": "customers",
      "animation": "ecodesign",
      "text": "Effizientere Antriebe, Standby-Abschaltung, Energiemonitoring. Spart Ihren Kunden Stromkosten – ein Verkaufsargument."
    },
    "take_back": {
      "label": "Rücknahme & Recycling",
      "short": "Kreislauf schließen",
      "scope": "3",
      "cost": 3,
      "targets": {
        "end_of_life": 0.4,
        "waste": 0.3
      },
      "station": "recycling",
      "animation": "circular",
      "text": "Rücknahmesystem für Altprodukte und sortenreine Trennung im Werk. Wertstoffe gehen zurück in die Produktion."
    }
  }
}
